import { useTranslation } from "next-i18next";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import getInThePressPosts from "@lib/requests/getInThePressPosts";
import getRecentPosts from "@lib/requests/getRecentPosts";

import Layout from "@components/layout";
import InThePressHead from "@components/screens/head/in-the-press";
import Header from "@components/screens/header";
import AdventAnnounce from "@components/screens/advent-announce";
import Footer from "@components/screens/footer";
import InThePressContent from "@components/screens/in-the-press-content";

const InThePressPage = ({ locale, inThePressPosts, recentPosts }) => {
  const { t } = useTranslation("common");
  const isInThePressPage = true;

  return (
    <Layout locale={locale}>
      <Layout.PageHead>
        <InThePressHead 
          locale={locale}
          title={locale === "ar" ? `${t("ONLYOFFICE Blog")} | ${t("ONLYOFFICE IN THE PRESS")}` : `${t("ONLYOFFICE IN THE PRESS")} | ${t("ONLYOFFICE Blog")}`}
        />
      </Layout.PageHead>
      <AdventAnnounce locale={locale} />
      <Layout.PageHeader>
        <Header t={t} locale={locale} />
      </Layout.PageHeader>
      <Layout.SectionMain>
        <InThePressContent t={t} locale={locale} inThePressPosts={inThePressPosts} recentPosts={recentPosts} isInThePressPage={isInThePressPage} />
      </Layout.SectionMain>
      <Layout.PageFooter>
        <Footer locale={locale} />
      </Layout.PageFooter>
    </Layout>
  )
}

export const getStaticProps = async ({ locale }) => {
  const inThePressPosts = await getInThePressPosts(locale, 60, null);
  const recentPosts = await getRecentPosts(locale);

	return {
		props: {
      ...(await serverSideTranslations(locale, "common")),
      locale,
      inThePressPosts: inThePressPosts ? inThePressPosts : null,
      recentPosts
    },
		revalidate:false,
	}
}

export default InThePressPage;